import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import axios from "axios";
import InputPagamento from "../components/Inputs/InputPagamento";
import { CheckCheck, ChevronLeft, LoaderCircle, OctagonAlert } from "lucide-react";
import { jwtDecode } from "jwt-decode";
import { AuthContext } from "../Contexts/AuthContext";
import MpesaStatusCard from "../components/Cards/MpesaStatusCard";
import { getMpesaFeedback } from "../utils/mpesaResponses";
import { criarReciboPagamento, montarReciboPagamento } from "../utils/recibosPagamento";

const API_URL =
  process.env.REACT_APP_API_URL ||
  (typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:8002"
    : "https://api-eyazs-production-8f74.up.railway.app");

export default function PagamentoViaMpesa() {
  const navigate = useNavigate();
  const { atualizarPlanoLocal } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [mensagemInput, setMensagemInput] = useState("");
  const [pagamentoStatus, setPagamentoStatus] = useState(null);
  const [profile, setProfile] = useState("");
  const [preco, setPreco] = useState(null);
  const [numero, setNumero] = useState("");
  const [valor, setValor] = useState("");
  const [meses, setMeses] = useState(1);
  const [pago, setPago] = useState(false);
  const [plano, setPlano] = useState("");
  const [trimestre, setTrimestre] = useState(false);
  const totalPagamento = useMemo(
    () => Number(preco || valor || 0) * Number(meses || 1),
    [meses, preco, valor]
  );

  async function mostrarPlano() {
    try {
      const token = localStorage.getItem("token");
  
      if (!token) {
        console.warn("Token não encontrado!");
        return;
      }
  
      const parsedToken = JSON.parse(token);
      const dadosDoLocalStorage = jwtDecode(parsedToken);
  
      if (!dadosDoLocalStorage?.idUsuario) {
        console.warn("Token inválido!");
        return;
      }
  
      const response = await axios.get(
        `${API_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
        {
          headers: { Authorization: `Bearer ${parsedToken}` } // Enviando token no header
        }
      );
        if(response.data){
          if(response.data.validadeusuario === "3 meses"){
            setTrimestre(true)
            console.log("Trimestral")
            console.log(trimestre)
          }else if(response.data.validadeusuario===null){
            setTrimestre(false)
            console.log(trimestre)
          }
          if(response.data.profileusuario === "PLANO-6Mbps" && response.data.precousuario === 2320){
            setPlano("PLANO FERRO 3Mbps")
            setValor(2320)
            setPreco(2320)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-8Mbps" && response.data.precousuario === 3480){
            setPlano("PLANO PRATA 5Mbps")
            setValor(3480)
            setPreco(3480)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-10Mbps" && response.data.precousuario === 5800){
            setPlano("PLANO COBRE 8Mbps")
            setValor(5800)
            setPreco(5800)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-12Mbps" && response.data.precousuario === 8120){
            setPlano("PLANO ALUMINIO 10Mbps")
            setValor(8120)
            setPreco(8120)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-14Mbps" && response.data.precousuario === 9628){
            setPlano("PLANO OURO 12Mbps")
            setValor(9628)
            setPreco(9628)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-16Mbps" && response.data.precousuario === 11948){
            setPlano("PLANO CHUMBO 14Mbps")
            setValor(11948)
            setPreco(11948)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-18Mbps" && response.data.precousuario === 13688){
            setPlano("PLANO MERCURIO 16Mbps")
            setValor(13688)
            setPreco(13688)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-20Mbps" && response.data.precousuario === 14500){
            setPlano("PLANO PLATINA 18Mbps")
            setValor(14500)
            setPreco(14500)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-20Mbps" && response.data.precousuario === 16008){
            setPlano("PLANO RODIO 20Mbps")
            setValor(16008)
            setPreco(16008)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-4Mbps" && response.data.precousuario === 18000){
            setPlano("PLANO 4Mbps")
            setValor(18000)
            setPreco(18000)   
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-8Mbps" && response.data.precousuario === 27000){
            setPlano("PLANO 6Mbps")
            setValor(27000)
            setPreco(27000)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-10Mbps" && response.data.precousuario === 36000){
            setPlano("PLANO 8Mbps")
            setValor(36000)
            setPreco(36000)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-12Mbps" && response.data.precousuario === 45000){
            setPlano("PLANO 10Mbps")
            setValor(45000)
            setPreco(45000)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-14Mbps" && response.data.precousuario === 67200){
            setPlano("PLANO 15Mbps")
            setValor(67200)
            setPreco(67200)
            setProfile(response.data.profileusuario)
          }else if(response.data.profileusuario === "PLANO-20Mbps" && response.data.precousuario === 9200){
            setPlano("PLANO 20Mbps")
            setValor(9200)
            setPreco(9200)
            setProfile(response.data.profileusuario)
          }
        }else{
            console.log("houve erro")
        }

    } catch (erro) {
      console.error("Erro ao buscar os dados do usuário:", erro);
    }
  }

  const gerarLetrasAleatorias = (tamanho) => {
    const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let resultado = "";
    for (let i = 0; i < tamanho; i++) {
      resultado += letras.charAt(Math.floor(Math.random() * letras.length));
    }
    return resultado;
  };

  const gerarDataAtual = () => {
    const dataAtual = new Date();
    // Obtém as partes da data
    const ano = dataAtual.getFullYear();
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
    const dia = String(dataAtual.getDate()).padStart(2, "0");

    // Obtém as partes do horário
    const horas = String(dataAtual.getHours()).padStart(2, "0");
    const minutos = String(dataAtual.getMinutes()).padStart(2, "0");
    const segundos = String(dataAtual.getSeconds()).padStart(2, "0");

    // Constrói a data no formato desejado
    const dataFormatada = `${ano}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
    return dataFormatada;
  };

  async function recarregarPacote() {
    setMensagemInput("");
    setPagamentoStatus(null);
    setLoading(true);
    try {
    const token = JSON.parse(localStorage.getItem("token"));
      if (!/^(84|85)\d{7}$/.test(numero)) {
        console.log(
          "Número de telefone inválido. Deve começar com 84 ou 85 e conter 9 dígitos."
        );
        setLoading(false);
        setMensagemInput(
          "Por favor, insira um número de telefone válido no maximo 9 numeros começando com 84 ou 85."
        );
        return;
      }
      let valoresAleatorios = gerarLetrasAleatorias(12);
      if(token){
        const dadosDoLocalStorage = jwtDecode(token)
        if(dadosDoLocalStorage){
          if (!profile || profile === "default") {
            setPagamentoStatus({
              code: "PLANO",
              message: "Ainda nao existe pacote ativo para renovar. Use Primeiro pagamento para escolher o pacote.",
              type: "error",
            });
            return;
          }
          const dataTransacaoPagamento = gerarDataAtual();
          const reciboPagamento = montarReciboPagamento({
            idUsuario: dadosDoLocalStorage.idUsuario,
            userName: dadosDoLocalStorage.name,
            numeroTelefone: numero,
            valor: totalPagamento,
            plano: profile,
            descricao: `${profile} - ${meses} mes(es)`,
            dataTransacao: dataTransacaoPagamento,
            referenciaPagamento: valoresAleatorios,
          });
          const dadosPagamento = await axios.put(
            `${API_URL}/${trimestre?"pagamentotrimestre":"pagamento"}/${dadosDoLocalStorage.idUsuario}`,
            {
              transaction_ref: "EyazsImperium",
              msisdn: `258${numero}`,
              amount: parseFloat(totalPagamento),
              thirdparty_ref: valoresAleatorios,
              meses: Number(meses),
              criarRecibo: true,
              numeroTelefone: numero,
              plano: profile,
              profile: profile,
              profileusuario: profile,
              precousuario: parseFloat(preco),
              descricaoRecibo: reciboPagamento.descricao,
              dataTransacao: dataTransacaoPagamento,
              referenciaPagamento: valoresAleatorios,
            },
            {
              headers:{
                'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
              }
            }
          );
          if (dadosPagamento) {
            const feedbackPagamento = getMpesaFeedback(dadosPagamento.data);
            if (feedbackPagamento.code !== "INS-0") {
              setPagamentoStatus(feedbackPagamento);
              return;
            }

            const profileBackUp = await axios.get(
              `${API_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
              {
                headers: {
                  'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                  'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                }
              }
            );
            if (profileBackUp) {
              try {
                console.log("plano atualizado!");
                const atualizarPlano = await axios.put(
                  `${API_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
                  {
                    profile: profileBackUp.data.profileusuario,
                  },
                  {
                    headers: {
                      'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                      'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                    }
                  }
                );
                if (atualizarPlano) {
                  const atualPrecoUsuario = await axios.put(
                    `${API_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
                    {
                      precousuario: parseFloat(preco),
                      profileusuario: profile
                    },
                    {
                      headers: {
                        'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                        'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                      }
                    }
                  );
                  if (atualPrecoUsuario) {
                    if (atualPrecoUsuario) {
                      console.log(
                        "Preco e Plano do usuario Atualizados com Sucesso!"
                      );
                      try {
                        if (!dadosPagamento.data?.reciboCriado && !dadosPagamento.data?.reciboId) {
                          await criarReciboPagamento({
                            apiUrl: API_URL,
                            token,
                            recibo: reciboPagamento,
                          });
                        }
                        console.log("Recibo gerado com Sucesso!");
                        setNumero("");
                        setPagamentoStatus(getMpesaFeedback(dadosPagamento.data));
                        atualizarPlanoLocal(profileBackUp.data.profileusuario || profile);
                        setPlano(profileBackUp.data.profileusuario || profile);
                        setPago(false);
                      } catch (erro) {
                        console.log(erro);
                        const planoAtualizado = profileBackUp.data.profileusuario || profile;
                        atualizarPlanoLocal(planoAtualizado);
                        setPlano(planoAtualizado);
                        setPagamentoStatus(getMpesaFeedback(dadosPagamento.data));
                        setPago(false);
                      }
                    }
                    console.log("Plano atualizado com Sucesso!");
                  }
                }
              } catch (erro) {
                console.log(erro);
              }
            }
            console.log(dadosPagamento.data);
          }
        }
      }
    } catch (erro) {
      console.log(erro);
      setPagamentoStatus(getMpesaFeedback(erro));
    } finally {
      setLoading(false);
    }
  }

  const propsInputPagamentoMpesa = {
    type: "text",
    placeholder: "digite o numero do Mpesa",
    mudar: (e) => setNumero(e.target.value),
    value: numero,
  };

  useEffect(() => {
    mostrarPlano();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* NavBar */}
      <div className="bg-blue-500 sticky top-0">
        <NavBar />
      </div>

      {/* Conteúdo Principal */}
      {pago ? (
        <div>
          <div className="flex justify-center items-center h-full">
            <div className="bg-green-700 m-8 text-white p-6 md:p-10 rounded-3xl shadow-2xl max-w-md w-full text-center">
              <div className="flex justify-center mb-4">
                <CheckCheck size={50} strokeWidth={2} />
              </div>
              <h1 className="text-2xl md:text-3xl font-bold mb-2">
                Pagamento Confirmado!
              </h1>
              <p className="text-lg md:text-xl mb-4">
                Obrigado pelo seu pagamento. Seu plano foi atualizado com
                sucesso.
              </p>
              <Link
                to="/home"
                className="inline-block mt-4 px-6 py-2 rounded-lg bg-green-500 text-gray-100 hover:bg-green-600 transition duration-300 font-semibold"
              >
                Voltar à Página Inicial
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex-grow flex flex-col justify-between font-questrial">
          <button
            className="group ml-6 my-2"
            onClick={() => {
              navigate(-1);
            }}
          >
            <div className="flex md:flex lg:hidden">
              <div>
                <ChevronLeft className="group-hover:font-semibold" />
              </div>
              <div>
                <span className="text-sm group-hover:font-semibold">
                  Voltar
                </span>
              </div>
            </div>
          </button>
          {/* Título do Perfil */}
          <div className="h-[60px] border flex items-center justify-center bg-gray-100">
            <h2 className="font-semibold">{plano}</h2>
          </div>

          {/* Seção de Pagamento */}
          <div className="border lg:mx-auto w-[80%] mx-auto sm:mx-auto sm:w-[40%] md:w-[40%] lg:w-[40%] bg-gray-50 my-6 p-6 rounded-lg shadow-md">
            {/* Logotipo */}
            <div className="flex justify-center mb-6">
              <img
                className="w-[170px]"
                src="../../images/vodacom.png"
                alt="Vodacom"
              />
            </div>

            <div className="flex items-center justify-between gap-3 mb-4 text-lg">
              <label htmlFor="mesesPagamento">Meses</label>
              <input
                id="mesesPagamento"
                type="number"
                min="1"
                value={meses}
                onChange={(e) =>
                  setMeses(Math.max(1, Number(e.target.value) || 1))
                }
                className="w-24 rounded border border-gray-300 px-3 py-2 text-right outline-none focus:border-blue-500"
              />
            </div>

            {/* Total */}
            <div className="flex justify-between mb-4 text-lg">
              <span>Total</span>
              <span className="font-semibold">{totalPagamento} MZN</span>
            </div>

            {/* Input de Pagamento */}
            <MpesaStatusCard
              status={pagamentoStatus}
              onClose={() => setPagamentoStatus(null)}
            />
            <div className="w-full mb-4">
              <InputPagamento {...propsInputPagamentoMpesa} />
            </div>

            {/* Botão de Pagamento */}
            {loading ? (
              <button className="w-full mt-4 bg-blue-500 p-2 text-white rounded-lg">
                <div className="flex justify-center items-center gap-1">
                  <span>Processando</span>
                  <LoaderCircle
                    strokeWidth={4}
                    size={18}
                    className={loading ? "animate-spin text-white" : ""}
                  />
                </div>
              </button>
            ) : (
              <button
                onClick={() => {
                  recarregarPacote();
                  // Certifique-se de que esta função esteja corretamente definida
                }}
                className="w-full mt-4 bg-blue-500 p-2 text-white rounded-lg hover:bg-blue-400"
              >
                Pagar
              </button>
            )}
            {mensagemInput && (
              <div className="flex items-center text-sm mt-2 p-4 bg-red-500 text-white rounded-lg">
                <OctagonAlert />
                <span>{mensagemInput}</span>
              </div>
            )}

            {/* Aviso sobre termos e condições */}
            <div className="mt-4 text-center text-sm text-gray-400">
              Ao clicar "Pagar", eu confirmo que li e estou de acordo{" "}
              <Link className="text-blue-500 hover:underline" to="/termosdeuso">
                com os termos e condições de uso
              </Link>
            </div>
          </div>
        </div>
      )}
      {/* Footer */}
      <div className="bg-blue-500 text-gray-200 p-2">
        <Footer />
      </div>
    </div>
  );
}
